import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductBundle } from './components/ProductBundle';
import { AudienceSection } from './components/AudienceSection';
import { StepsSection } from './components/StepsSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '962544723385858');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen flex flex-col font-body text-gray-800 bg-cream selection:bg-gold/30 selection:text-deep-teal" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <ProductBundle data-id="element-6" />
        <AudienceSection data-id="element-7" />
        <StepsSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <OfferBlock data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}